module.exports = __webpack_public_path__ + "img/beer_factory.36fe0e69.svg";